import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { EditableProperty } from './EditableProperty';

export const EditableContactProperty = ({
  entity,
  preChange,
  changeHandler,
  patchField,
  placeholder,
  editFormatter,
  labelFormatter,
}) => (
  <EditableProperty
    dto={entity}
    preChange={preChange}
    changeHandler={changeHandler}
    patchField={patchField}
    placeholder={placeholder}
    targetUrl={`${process.env.REACT_APP_AUTH_SERVICE_URL}/contacts/${entity.id}`}
    editFormatter={editFormatter}
    labelFormatter={labelFormatter}
  />
);

EditableContactProperty.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    lastModified: PropTypes.string.isRequired,
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  editFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
  labelFormatter: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.func]).isRequired,
};
